// Companies Module - Root Reducers
// This file aggregates all companies-related reducers

import CompaniesListReducer from './List/store/slice'
import CompaniesFormReducer from './Form/store/slice'

const companiesReducers = {
  ...CompaniesListReducer,
  ...CompaniesFormReducer,
}

export default companiesReducers

